import React, { memo, useContext } from 'react';
import Flex from 'components/common/Flex';
import { Nav, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatContext } from 'context/Context';

const ChatFeatures = () => {
    const { setCurrentThread, setShowSearchModal } = useContext(ChatContext);
    return (
        <Nav.Link
            eventKey={null}
            className='p-3 w-100 cursor-default position-sticky top-0 bg-light'
            style={{ zIndex: 1 }}
        >
            <Flex>
                <div className="flex-1 chat-contact-body ms-2 d-md-none d-lg-block">
                    <div className="min-w-0">
                        <Row>
                            <Col>
                                <Button
                                    className='w-100 text-primary'
                                    variant="falcon-primary"
                                    size="sm"
                                    id="btnChatNew"
                                    title="Start a new chat"
                                    onClick={() => setCurrentThread(null)}
                                >
                                    <FontAwesomeIcon icon="plus" className="text-primary bounce" />
                                    <span className="d-none d-md-inline ms-2">New chat</span>
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className='w-100 text-primary'
                                    variant="falcon-primary"
                                    size="sm"
                                    id="btnSearch"
                                    title="Search chats"
                                    onClick={() => setShowSearchModal(true)}
                                >
                                    <FontAwesomeIcon icon="search" className="text-primary" />
                                    <span className="d-none d-md-inline ms-2">Search</span>
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Flex>
        </Nav.Link>
    );
};

export default memo(ChatFeatures);
